import Link from 'next/link'
import ArrowTopIcon from 'public/icons/arrow/top.svg'
import { VFC } from 'react'

export const GotoTopIcon: VFC<{ href: string }> = ({ href }) => {
  return (
    <div
      style={{
        display: 'flex',
        position: 'fixed',
        right: '16px',
        bottom: '32px',
        width: '60px',
        height: '60px',
        border: '1px solid #000',
        background: 'var(--ax-white, #FFF)',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer',
        zIndex: 5,
      }}
    >
      <Link href={`#${href}`}>
        <a>
          <ArrowTopIcon width={24} height={24} />
        </a>
      </Link>
    </div>
  )
}
